import * as Scrivito from "scrivito";

const CarouselWidget = Scrivito.provideWidgetClass("CarouselWidget", {
  attributes: {
    images: ["referencelist", { only: ["Image"] }],
  },
});

export default CarouselWidget;
